import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { withUserContext } from './with-user-context';

/** The only page a restricted Authorized User can open (their own sessions). */
export const RESTRICTED_LANDING = '/admin/audit-log';

/**
 * Keeps a restricted Authorized User — no data type, or no location when the org has
 * Location Management on — off the monitoring pages, sending them to their own
 * Session Audit Log.
 * Waits for the user context; with none it fails closed to /unauthorized
 * (SECURITY-08). List it before dataTypeGuard so the redirect wins.
 */
export const accessRestrictedGuard: CanActivateFn = () => {
  const router = inject(Router);
  return withUserContext((context) =>
    context.accessRestricted ? router.createUrlTree([RESTRICTED_LANDING]) : true,
  );
};
